import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { BrowserView } from 'react-device-detect'

import Navbar from '../components/navbar'
import NavbarFooter from '../components/navbar/NavbarFooter'
import CasinosList from '../components/casino/CasinosList'
import CasinoSearchAndSort from '../components/casino/CasinoSearchAndSort'
import { RefreshSlotProvider } from '../components/casino/RefreshSlotContext'
import ResponsibleGamingFooter from '../components/ResponsibleGamingFooter'
import mobileLogoImage from '../assets/crapapp-logo.svg'
import desktopLogoImage from '../assets/welcome-to-crapapp.svg'

export default function HomePage() {
    return (
        <RefreshSlotProvider>
            <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Navbar showSearch={true} />
                <Container component="main" sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', py: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                        <Box component="img" src={mobileLogoImage} alt="CrapApp Logo" sx={{ height: 60, display: { xs: 'block', sm: 'none' } }} />
                        <Box component="img" src={desktopLogoImage} alt="CrapApp Logo" sx={{ height: 60, display: { xs: 'none', sm: 'block' } }} />
                    </Box>
                    <BrowserView renderWithFragment>
                        <Box
                            sx={(theme) => ({
                                position: 'sticky',
                                top: { xs: 56, sm: 64 },
                                zIndex: theme.zIndex.appBar - 1,
                                backgroundColor: theme.palette.background.default,
                            })}
                        >
                            <CasinoSearchAndSort />
                        </Box>
                    </BrowserView>
                    <CasinosList />
                </Container>
                <ResponsibleGamingFooter />
                <NavbarFooter />
            </Box>
        </RefreshSlotProvider>
    )
}
